import { render } from "./AboutView.vue?vue&type=template&id=6cf3f21e&scoped=true&ts=true"
import script from "./AboutView.vue?vue&type=script&lang=ts"
export * from "./AboutView.vue?vue&type=script&lang=ts"

import "./AboutView.vue?vue&type=style&index=0&id=6cf3f21e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cf3f21e"]])

export default __exports__